import { isNil } from 'lodash'

export default function limitFilesToRemainingSlots(
  newFiles,
  currentFileCount,
  maxFiles
) {
  if (isNil(maxFiles)) return newFiles

  const remainingSlots = Math.max(maxFiles - currentFileCount, 0)
  return newFiles.slice(0, remainingSlots)
}
